
import { takeLatest } from 'redux-saga/effects';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/frontDeskDetailType';

function* frontDeskDetailSaga(data: any): Generator {
  const { requestIdDecoded, setFrontDetails, setTimeLineDetails } = data.payload;

  const sendRequest = SendRequest.instance;
  const request = {
    requestId: +requestIdDecoded,
  };
  const url = `${GLOBAL_URL.CRM_OUTPATIENT_URL}Provider/FetchAppointmentDetail`;
  try {
    const response: any = yield sendRequest.post<any, any>
      (url, request);

    if (response && response.isSuccess && response.requestDetails) {
      setFrontDetails(response.requestDetails[0]);
    }
    if (response &&
      response.isSuccess &&
      response.requestFlow &&
      response.requestFlow.isSuccess &&
      response.requestFlow.requestFlowDetails) {
        setTimeLineDetails(response.requestFlow.requestFlowDetails);
    }
    return;
  } catch (e) {
  }
}

export function* watchFrontDeskDetailAction(): any {
  yield takeLatest(actionTypes.FRONT_DESK_DETAIL, frontDeskDetailSaga);
}

export default watchFrontDeskDetailAction;
